const ActionBar = ({title, onSearch, searchPlaceholder = "Search", showSearch = false, additionalActions}) => {
    return (
        <div className="px-8 py-6 border-b border-zinc-700">
            <div className="flex justify-between items-center">
                <h1 className="text-5xl">{title}</h1>
                {(showSearch || additionalActions) && (
                    <div className="flex items-center space-x-3">
                        {showSearch && (
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder={searchPlaceholder}
                                    onChange={(e) => onSearch && onSearch(e.target.value)}
                                    className="bg-charleston-green border border-zinc-700 rounded-full px-5 py-2.5 pr-10 text-white placeholder-zinc-500 w-[400px] focus:outline-none focus:border-zinc-600"
                                />
                                <svg
                                    className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </div>
                        )}
                        {additionalActions}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ActionBar;